import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { Dialog } from 'primeng/dialog';
import { MxBaseComponent } from 'src/app/core/base/mx.base-component';

@Component({ standalone: false,
  selector: 'mx-dialog',
  templateUrl: './mx.dialog.component.html',
  styleUrls: ['./mx.dialog.component.scss'],
})
export class MxDialogComponent extends MxBaseComponent implements OnInit {
  @ViewChild('dialog') dialog: Dialog;

  /* Title text of the dialog. */
  @Input() header: string;

  /* Enables dragging to change the position using header. */
  @Input() draggable: boolean = true;

  /* Keeps dialog in the viewport. */
  @Input() keepInViewport: boolean = true;

  /* Enables resizing of the content. */
  @Input() resizable: boolean = true;

  /* Specifies the visibility of the dialog. */
  @Input() visible: boolean;

  /* Defines if background should be blocked when dialog is displayed. */
  @Input() modal: boolean = true;

  /* Position of the dialog, options are "center", "top", "bottom", "left", "right", "topleft", "topright", "bottomleft" or "bottomright". */
  @Input() position: 'center' | 'top' | 'bottom' | 'left' | 'right' | 'topleft' | 'topright' | 'bottomleft' | 'bottomright';

  /* Whether background scroll should be blocked when dialog is visible. */
  @Input() blockScroll: boolean;

  /* 	Specifices if pressing escape key should hide the dialog. */
  @Input() closeOnEscape: boolean = true;

  /* Specifices if clicking the modal background should hide the dialog. */
  @Input() dismissableMask: boolean = true;

  /* 	Adds a close icon to the header to hide the dialog. */
  @Input() closable: boolean = true;

  /* Target element to attach the dialog, valid values are "body" or a local ng-template variable of another element (note: use binding with brackets for template variables, e.g. [appendTo]="mydiv" for a div element having #mydiv as variable name). */
  @Input() appendTo: any = 'body';

  /* Inline style of the component. */
  @Input() style: object;

  /* Style class of the component. */
  @Input() styleClass: string;

  /* Style class of the mask. */
  @Input() maskStyleClass: string;

  /* Inline style of the content. */
  @Input() contentStyle: object;

  /* Style class of the content. */
  @Input() contentStyleClass: string;

  /* Whether to show the header or not. */
  @Input() showHeader: boolean = true;

  /* Base zIndex value to use in layering. */
  @Input() baseZIndex: number = 0;

  /* Whether to automatically manage layering. */
  @Input() autoZIndex: boolean = true;

  /* Minimum value for the left coordinate of dialog in dragging. */
  @Input() minX: number = 0;

  /* Minimum value for the top coordinate of dialog in dragging. */
  @Input() minY: number = 0;

  /* When enabled, first button receives focus on show. */
  @Input() focusOnShow: boolean = true;

  /* When enabled, can only focus on elements inside the dialog. */
  @Input() focusTrap: boolean = true;

  /* Whether the dialog can be displayed full screen. */
  @Input() maximizable: boolean;

  /* Object literal to define widths per screen size. */
  @Input() breakpoints: any = { '960px': '75vw', '640px': '100vw' };

  /* Name of the close icon. */
  @Input() closeIcon: string = 'fa fa-times fa-fw';

  /* Name of the minimize icon. */
  @Input() minimizeIcon: string = 'pi pi-window-minimize';

  /* Name of the maximize icon. */
  @Input() maximizeIcon: string = 'pi pi-window-maximize';

  /* Specifies the visibility of the dialog. */
  @Output() visibleChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  /* Callback to invoke when dialog is shown. */
  @Output() mxOnShow: EventEmitter<any> = new EventEmitter<any>();

  /* Callback to invoke when dialog is hidden. */
  @Output() mxOnHide: EventEmitter<any> = new EventEmitter<any>();

  /* Callback to invoke when dialog resizing is initiated. */
  @Output() mxOnResizeInit: EventEmitter<any> = new EventEmitter<any>();

  /* Callback to invoke when dialog resizing is completed. */
  @Output() mxOnResizeEnd: EventEmitter<any> = new EventEmitter<any>();

  /* Callback to invoke when dialog dragging is completed. */
  @Output() mxOnDragEnd: EventEmitter<any> = new EventEmitter<any>();

  /* Callback to invoke when dialog maximized or unmaximized. */
  @Output() mxOnMaximize: EventEmitter<any> = new EventEmitter<any>();

  constructor() {
    super();
  }

  ngOnInit(): void {}

  onShow(event: any) {
    this.mxOnShow.emit(event);
  }

  onHide(event: any) {
    this.visibleChange.emit(this.visible);
    this.mxOnHide.emit(event);
  }

  onResizeInit(event: any) {
    this.mxOnResizeInit.emit(event);
  }

  onResizeEnd(event: any) {
    this.mxOnResizeEnd.emit(event);
  }

  onDragEnd(event: any) {
    this.mxOnDragEnd.emit(event);
  }

  onMaximize(event: any) {
    this.mxOnMaximize.emit(event);
  }
}
